import script from "./IssuesByLocationChart.vue?vue&type=script&setup=true&lang=js"
export * from "./IssuesByLocationChart.vue?vue&type=script&setup=true&lang=js"

import "./IssuesByLocationChart.vue?vue&type=style&index=0&id=0d30cbc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d30cbc8"]])

export default __exports__